module.exports = __webpack_public_path__ + "static/media/Galdisa_WhiteRoastSeed.70c5750f.pdf";